if (!customElements.get('article-products')) {

  class ArticleProducts extends HTMLElement {

    constructor() {
      super();

      this.productCards = this.querySelector('[data-article-product-cards]');
      this.searchTemplate = this.getAttribute('data-product-card') == 'small' ? 'sku-small' : 'sku';

      /*if in specific carousel*/
      this.isCarousel = false;
      if(this.productCards.classList.contains('carousel')){
        this.isCarousel = true;
        this.productCards = this.productCards.querySelector('.flickity-slider');
      }

      /**
       * Fetch SKU Products from data-attribute
       */
      if (this.hasAttribute('data-skus')) {
        this.fetchSKUS(this.getAttribute('data-skus'));
      }
      
    }

    fetchSKUS(skus) {
        try {
            skus = JSON.parse(skus);
            if (skus.length) {
                skus = [...new Set(skus)]; /*uniq*/
                skus = this.updatedSkus(skus);
                skus = skus.map(sku => `variants.sku:${sku}\*`);
                let url;
                if(this.hasAttribute('data-locale')) {
                    url = new URL(`${window.location.origin}/${this.getAttribute('data-locale')}/search`);
                } else {
                    url = new URL(`${window.location.origin}/search`);
                }
                url.search = new URLSearchParams({ q: skus.join(' OR '), type: "product", view: this.searchTemplate }).toString();
                fetch(url).then(r => r.json()).then(r => this.parseResults(r));
            }
        } catch (error) {
            console.log(error)
        }
    }

    /**
     * 
     * Interprets the result of the search fetch and replaces all virtual skeleton loading slides of swiper
     * 
     * @param {Object} r 
     */
     parseResults(r) {
      if (r && r.results_count > 0) {
        let html = '';
        r.results.forEach((product, i) => {
            var pcard = new DOMParser().parseFromString(product.cardHtml, 'text/html').querySelector('body').innerHTML;
            if(this.isCarousel){
              this.productCards.children.item(i).innerHTML = pcard;
            } else {
              html += '<div class="column">'+ pcard +'</div>';
            }
        });

        if(this.isCarousel){
          this.productCards.querySelectorAll('.product-card-empty').forEach(empty_card => empty_card.parentNode.remove());
        } else {
          this.productCards.innerHTML = html;
        }

        this.customCarouselHeight();
        this.cartRecommendations(r.results.length);
      } else {
        /*removes new lines after element parent - possible not needed anymore*/
        if (this.parentNode.nextElementSibling?.tagName == 'BR') {
          this.parentNode.nextElementSibling.remove();
        }
        if (this.parentNode.nextElementSibling?.tagName == 'BR') {
          this.parentNode.nextElementSibling.remove();
        }
        if (this.parentNode.nextElementSibling?.tagName == 'BR') {
          this.parentNode.nextElementSibling.remove();
        }
        if (this.parentNode.nextElementSibling?.tagName == 'BR') {
          this.parentNode.nextElementSibling.remove();
        }
        this.parentNode.remove();
      }
    }

    customCarouselHeight(){
      if(!this.isCarousel) return false;
      let flickityViewport = this.productCards.closest('.flickity-viewport');
      if(!flickityViewport) return false;
      let h = Math.max(...Array.from(this.productCards.childNodes).map(slide => slide.offsetHeight));
      flickityViewport.style.minHeight = (h === -Infinity) ? '0px' : h + 'px';
    }

    cartRecommendations(results_length){
      if(!this.closest('#Cart-Drawer') || results_length<1) return;
      const cartRecommendations = this.closest('#Cart-Drawer').querySelector('.product-recommendations--parent');
      cartRecommendations.classList.add('product-recommendations--full');
      if(document.getElementById('Cart-Drawer').classList.contains('active')){
        cartRecommendations.classList.add('active');
      }
    }

    updatedSkus(skus){
      const old_to_new = {
'SHOE_TREE-S0001RS': '12333',
'ROSS_4-A0001': '11932000002',
'ROSS_3-A0001': '11931000002',
'ROSS_2-A0001': '11930000002',
'ROSS_1-A0001': '11929000002',
'PREMIUM_CREAM-A0024-50': '114903000001',
'PREMIUM_CREAM-A0023-50': '114902000001',
'PREMIUM_CREAM-A0022-50': '114901000001',
'PREMIUM_CREAM-A0021-50': '114900000001',
'PREMIUM_CREAM-A0020-50': '11844000002',
'PREMIUM_CREAM-A0019-50': '11843000002',
'PREMIUM_CREAM-A0018-50': '11841000002',
'PREMIUM_CREAM-A0017-50': '11839000002',
'PREMIUM_CREAM-A0016-50': '11838000002',
'PREMIUM_CREAM-A0015-50': '11837000002',
'PREMIUM_CREAM-A0014-50': '11836000002',
'PREMIUM_CREAM-A0013-50': '11835000002',
'PREMIUM_CREAM-A0012-50': '11834000002',
'PREMIUM_CREAM-A0011-50': '11833000002',
'PREMIUM_CREAM-A0010-50': '11832000002',
'PREMIUM_CREAM-A0009-50': '11831000002',
'PREMIUM_CREAM-A0008-50': '11830000002',
'PREMIUM_CREAM-A0007-50': '11829000002',
'PREMIUM_CREAM-A0006-50': '11828000002',
'PREMIUM_CREAM-A0005-50': '11827000002',
'PREMIUM_CREAM-A0004-50': '11826000002',
'PREMIUM_CREAM-A0003-50': '11825000002',
'PREMIUM_CREAM-A0002-50': '11824000002',
'PREMIUM_CREAM-A0001-50': '11823000002',
'NOURISHING_CREAM-A0001': '11748000002',
      };
      return skus.map(sku => old_to_new[sku] || sku);
    }
  }

  customElements.define('article-products', ArticleProducts);

}


